import { CustodiansSearchField } from 'components/secondaryMarket/shared/Custodians/CustodiansSearchField';
import { Custodian } from 'models/custodian';
import { useCallback } from 'react';
import { asSecondaryCellEditorProps, SecondaryCellProps } from 'routes/secondary-market-batch/grid/types';
import { of } from 'rxjs';
import { isPrintableKey } from 'utils/aggrid';

export function CustodianCellEditor({ value, colDef, node, data, ...props }: SecondaryCellProps<Custodian>) {
  const { stopEditing, eventKey } = asSecondaryCellEditorProps(props);
  const onCustodianChanged = useCallback(
    (custodian?: Custodian | null) => {
      node.setDataValue(colDef.field!, custodian ?? null);
      stopEditing?.();
    },
    [node, colDef.field, stopEditing],
  );
  const availableCustodians = colDef.context.metadataId
    ? (data?.metadata?.[colDef.context.metadataId] as Custodian[] | undefined)
    : undefined;
  const searchCustodians = useCallback(
    (text: string) => {
      const normalizedText = text.trim().toLowerCase();
      return of(
        (availableCustodians ?? []).filter(
          custodian =>
            custodian.label.toLowerCase().includes(normalizedText) ||
            custodian.id.toLowerCase().includes(normalizedText) ||
            custodian.eliotCode?.toLowerCase().includes(normalizedText),
        ),
      );
    },
    [availableCustodians],
  );
  const stopEditingOnClose = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) {
        stopEditing?.();
      }
    },
    [stopEditing],
  );
  return (
    <CustodiansSearchField
      autoOpen={props.type === 'editor'}
      buttonClassName="justify-content-start"
      isReadonly={props.type === 'renderer'}
      onOpenChange={stopEditingOnClose}
      onCustodianChanged={onCustodianChanged}
      selectedCustodian={value ?? undefined}
      defaultSearchedValue={isPrintableKey(eventKey) ? eventKey : undefined}
      searchCustodians={colDef.context.metadataId ? searchCustodians : undefined}
    />
  );
}
